import { affiliationData } from '../../../mocks/affiliation';

export default function Affiliation() {
  return (
    <section id="affiliation" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            {affiliationData.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" style={{ fontFamily: "'Inter', sans-serif" }}>
            {affiliationData.description}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="w-full max-w-md mx-auto lg:mx-0 h-[480px] rounded-xl overflow-hidden shadow-2xl bg-gray-100 flex items-center justify-center">
              <img
                src="https://static.readdy.ai/image/bb998e5e7406222cb7440e6d3ad6868b/ca94ca5b717939263bb78fadb13c494d.png"
                alt="Tom Shock - Chameleon Collective Partnership"
                className="w-full h-full object-contain object-center"
              />
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <h3 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              {affiliationData.partnershipTitle}
            </h3>
            <p className="text-base text-gray-700 mb-6 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
              {affiliationData.partnershipDescription}
            </p>
            <div className="space-y-4">
              {affiliationData.benefits.map((benefit, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-teal-600 text-xl"></i>
                  </div>
                  <p className="text-sm text-gray-700" style={{ fontFamily: "'Inter', sans-serif" }}>
                    <strong className="font-semibold text-gray-900">{benefit.title}:</strong> {benefit.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
